import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { RenderContainer } from "../../../internal/RenderContainer";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { isTestEnv } from "../../../lib/currentEnvironment";
import { styles } from "../Toast.styles";
import { ToastView } from "../ToastView";
import { ToastStatic } from "../ToastStatic";
/**
 * Показывает уведомления.
 *
 * Доступен статический метод: `Toast.push(notification, action?)`.
 * Однако, при его использовании не работает кастомизация и могут быть проблемы
 * с перекрытием уведомления другими элементами страницы.
 *
 * Рекомендуется использовать Toast через `ref` (см. примеры).
 */

export var Toast = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Toast, _React$Component);

  Toast.push = function push(notification, action) {
    ToastStatic.push(notification, action);
  };

  Toast.close = function close() {
    ToastStatic.close();
  };

  function Toast(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._toast = void 0;
    _this._timeout = null;

    _this.close = function () {
      safelyCall(_this.props.onClose, _this.state.notification, _this.state.action);

      _this.setState({
        notification: null,
        action: null
      });
    };

    _this._clearTimer = function () {
      if (_this._timeout) {
        clearTimeout(_this._timeout);
        _this._timeout = null;
      }
    };

    _this._setTimer = function () {
      _this._clearTimer();

      var timeOut = _this.state.action ? 7 : 3;
      _this._timeout = window.setTimeout(_this.close, timeOut * 1000);
    };

    _this._refToast = function (element) {
      _this._toast = element;
    };

    _this.state = {
      notification: null,
      action: null,
      id: 0
    };
    return _this;
  }

  var _proto = Toast.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearTimer();
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(RenderContainer, null, /*#__PURE__*/React.createElement(TransitionGroup, null, this._renderToast()));
  }
  /**
  * Показывает тост с `notification` в качестве сообщения.
  * Тост автоматически скрывается через 3 или 7 секунд,
  * в зависимости от наличия у него кнопки `action`.
  *
  * @public
  * @param {string} notification
  * @param {Action} action `action` опциональный параметр формата `{ label: string, handler: function }`
  * добавляет кнопку в виде ссылки при клике на которую вызывается переданный handler
  */
  ;

  _proto.push = function push(notification, action) {
    if (this.state.notification) {
      this.close();
    }

    safelyCall(this.props.onPush, notification, action);
    this.setState(function (_ref) {
      var id = _ref.id;
      return {
        notification: notification,
        action: action,
        id: id + 1
      };
    }, this._setTimer);
  }
  /**
  * @public
  */
  ;

  _proto._renderToast = function _renderToast() {
    var _this$state = this.state,
        notification = _this$state.notification,
        action = _this$state.action,
        id = _this$state.id;

    if (!notification) {
      return null;
    }

    var toastProps = {
      onMouseEnter: this._clearTimer,
      onMouseLeave: this._setTimer,
      onClose: this.close,
      children: notification,
      action: action
    };
    return /*#__PURE__*/React.createElement(CSSTransition, {
      key: id,
      classNames: {
        enter: styles.enter(),
        enterActive: styles.enterActive(),
        exit: styles.exit(),
        exitActive: styles.exitActive()
      },
      timeout: {
        enter: 200,
        exit: 150
      },
      enter: !isTestEnv,
      exit: !isTestEnv
    }, /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement(ToastView, _extends({
      ref: this._refToast
    }, toastProps))));
  };

  return Toast;
}(React.Component);
Toast.__KONTUR_REACT_UI__ = 'Toast';

function safelyCall(fn) {
  if (fn) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    fn.apply(void 0, args);
  }
}